import '../scss/specificity_pattern1.scss';

import controller from "../js/controller";
import loading from "../js/loading";
import navigation from "../js/navigation";

controller.init();
loading.load();
navigation.init();